import { css } from '@emotion/react'
import { FC } from 'react'

type Props = {
  name?: string
}

const FieldWrapper: FC<Props> = ({ name, children }) => {
  return (
    <div css={style()} data-cy={name}>
      {children}
    </div>
  )
}

export default FieldWrapper

const style = () => css`
  display: grid;
  row-gap: 5px;
  position: relative;

  @media (max-width: 767px) {
    row-gap: 2px;
  }
`
